import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { extendSession } from 'actions/auth';
import { resetForm } from 'actions/forms';
import { closeModal } from 'actions/modal';
import LoadingRenderer from 'components/LoadingRenderer';
import { Modal } from 'containers';
import Strings from 'Strings';

export const MODAL_CONFIRM_YOU_THERE = 'confirm-you-there';

const mapDispatchToProps = (dispatch, ownProps) => ({
  onCancel: () => dispatch(closeModal(MODAL_CONFIRM_YOU_THERE)),
  onSubmit: () =>
    dispatch(extendSession()).then(response => {
      if (!response?.error) {
        dispatch(closeModal(MODAL_CONFIRM_YOU_THERE));
      }
      return response;
    }),
  onOpen: () => dispatch(resetForm(MODAL_CONFIRM_YOU_THERE, ownProps.data)),
});

const formatCountdown = remainingMs => {
  const totalSeconds = Math.max(0, Math.ceil(remainingMs / 1000));
  const minutes = Math.floor(totalSeconds / 60);
  const seconds = totalSeconds % 60;
  return `${String(minutes).padStart(2, '0')}:${String(seconds).padStart(2, '0')}`;
};

function ConfirmYouThere(props) {
  const { data, onOpen, onSubmit, onCancel } = props;
  const [countdown, setCountdown] = useState(() => formatCountdown((data?.expiresAt || Date.now()) - Date.now()));

  useEffect(() => {
    const updateCountdown = () => {
      setCountdown(formatCountdown((data?.expiresAt || Date.now()) - Date.now()));
    };

    updateCountdown();
    const intervalId = setInterval(updateCountdown, 1000);

    return () => clearInterval(intervalId);
  }, [data?.expiresAt]);

  return (
    <Modal name={MODAL_CONFIRM_YOU_THERE} onOpen={onOpen} additionalClasses={['form-modal']} onCancel={onCancel}>
      <LoadingRenderer>
        <p>{Strings.idleSessionMessage}</p>
        <p>{Strings.formatString(Strings.idleSessionCountdown, countdown)}</p>

        <div className="button-bar reverse extend-button" key="button-bar">
          <button className="brand-blue" key="button" type="button" onClick={onSubmit}>
            {Strings.extend}
          </button>
        </div>
      </LoadingRenderer>
    </Modal>
  );
}

export default connect(null, mapDispatchToProps)(ConfirmYouThere);

ConfirmYouThere.propTypes = {
  data: PropTypes.shape({
    expiresAt: PropTypes.number,
  }),
  onCancel: PropTypes.func,
  onOpen: PropTypes.func,
  onSubmit: PropTypes.func,
};
